<template>
  <v-layout v-resize="onResize" column style="padding-top: 56px">
    <div class="table-size-limit pr-3">
      <v-data-table
        flat
        :headers="headers"
        :items="partners"
        :loading="isLoading"
        class="elevation-2 partners-table"
        click:row
        :hide-headers="isMobile"
        :class="{ mobile: isMobile }"
        :rows-per-page-items="limitOptions"
        :pagination.sync="pagination"
        :total-items="total"
      >
        <template slot="items" slot-scope="props">
          <tr v-if="!isMobile">
            <td class="text-xs-left">
              <a class="partner-link" @click="openDetails(props.item)">{{
                props.item.id
              }}</a>
            </td>
            <td class="text-xs-left">
              {{ setDateFormat(props.item.created_at) }}
            </td>
            <td class="text-xs-left">
              <a class="partner-link" @click="openDetails(props.item)">{{
                props.item.name
              }}</a>
            </td>
            <td class="text-xs-left">
              {{
                props.item.account_type === "business" ? "Comercial" : "Pessoal"
              }}
            </td>
            <td class="text-xs-left">{{ formatCpf(props.item.cpf) }}</td>
            <td class="text-xs-left">{{ formatCnpj(props.item.cnpj) }}</td>
            <td class="text-xs-left">
              {{ $t(`partner.${props.item.partner}`) }}
            </td>
            <td class="text-xs-left">
              {{ props.item.plan_name || "—" }}
            </td>
            <td class="text-xs-center">
              <router-link
                :to="{ name: 'partner', params: { id: props.item.id } }"
              >
                Exibir
              </router-link>
              <router-link
                class="ml-2"
                :to="{
                  name: 'partners_payments',
                  query: { establishment: props.item.id },
                }"
              >
                Pagamentos e Recebíveis
              </router-link>
            </td>
          </tr>
          <tr v-else>
            <td>
              <ul class="flex-content">
                <li class="flex-item" data-label="ID">{{ props.item.id }}</li>
                <li class="flex-item" data-label="Criada em">
                  {{ setDateFormat(props.item.created_at) }}
                </li>
                <li class="flex-item" data-label="Nome">
                  <a class="partner-link" @click="openDetails(props.item)">{{
                    props.item.name
                  }}</a>
                </li>
                <li class="flex-item" data-label="Tipo de conta">
                  {{
                    props.item.account_type === "business"
                      ? "Comercial"
                      : "Pessoal"
                  }}
                </li>
                <li class="flex-item" data-label="CPF">
                  {{ formatCpf(props.item.cpf) }}
                </li>
                <li class="flex-item" data-label="CNPJ">
                  {{ formatCnpj(props.item.cnpj) }}
                </li>
                <li class="flex-item" data-label="Parceria">
                  {{ $t(`partner.${props.item.partner}`) }}
                </li>
                <li class="flex-item" data-label="Plano">
                  {{ props.item.plan_name || "—" }}
                </li>
                <li class="flex-item" data-label="Ações">
                  <router-link
                    :to="{
                      name: 'partner',
                      params: { id: props.item.id },
                    }"
                  >
                    Exibir
                  </router-link>
                  <router-link
                    class="ml-2"
                    :to="{
                      name: 'partners_payments',
                      query: { establishment: props.item.id },
                    }"
                  >
                    Pagamentos e Recebíveis
                  </router-link>
                </li>
              </ul>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="detailsDialog" max-width="640px" scrollable>
      <v-card v-if="selected">
        <div class="details-header">
          <div class="details-header-info">
            <div class="details-avatar">
              <v-icon dark>store</v-icon>
            </div>
            <div>
              <div class="details-name">{{ selected.name }}</div>
              <div class="details-sub">Estabelecimento #{{ selected.id }}</div>
            </div>
          </div>
          <v-btn icon dark @click="detailsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>

        <div class="details-chips">
          <span class="chip chip-partner">{{
            $t(`partner.${selected.partner}`)
          }}</span>
          <span
            class="chip"
            :class="selected.plan_name ? 'chip-plan' : 'chip-muted'"
          >
            {{ selected.plan_name || "Sem plano" }}
          </span>
          <span class="chip chip-muted">{{
            selected.account_type === "business" ? "Comercial" : "Pessoal"
          }}</span>
        </div>

        <v-card-text class="details-body" style="max-height: 62vh">
          <div class="detail-card">
            <div class="detail-title">Dados gerais</div>
            <div class="detail-row" v-if="selected.fantasy_name">
              <span>Nome fantasia</span><b>{{ selected.fantasy_name }}</b>
            </div>
            <div class="detail-row" v-if="selected.category_description">
              <span>Ramo</span><b>{{ selected.category_description }}</b>
            </div>
            <div class="detail-row">
              <span>Criada em</span><b>{{ setDateFormat(selected.created_at) }}</b>
            </div>
          </div>

          <div class="detail-card">
            <div class="detail-title">Documentos</div>
            <div class="detail-row">
              <span>CPF</span><b>{{ formatCpf(selected.cpf) }}</b>
            </div>
            <div class="detail-row" v-if="selected.rg">
              <span>RG</span><b>{{ selected.rg }}</b>
            </div>
            <div class="detail-row" v-if="selected.cnpj">
              <span>CNPJ</span><b>{{ formatCnpj(selected.cnpj) }}</b>
            </div>
            <div class="detail-row" v-if="selected.razao_social">
              <span>Razão social</span><b>{{ selected.razao_social }}</b>
            </div>
            <div class="detail-row" v-if="selected.owner_name">
              <span>Representante</span><b>{{ selected.owner_name }}</b>
            </div>
          </div>

          <div class="detail-card">
            <div class="detail-title">Contato</div>
            <div class="detail-row">
              <span>E-mail</span><b>{{ selected.email || "—" }}</b>
            </div>
            <div class="detail-row">
              <span>Telefone</span><b>{{ formatPhone(selected.phones_attributes) }}</b>
            </div>
          </div>

          <div class="detail-card" v-if="selected.address_attributes">
            <div class="detail-title">Endereço</div>
            <div class="detail-row">
              <span>Logradouro</span
              ><b>{{ formatStreet(selected.address_attributes) }}</b>
            </div>
            <div
              class="detail-row"
              v-if="selected.address_attributes.complement"
            >
              <span>Complemento</span
              ><b>{{ selected.address_attributes.complement }}</b>
            </div>
            <div class="detail-row">
              <span>Bairro</span
              ><b>{{ selected.address_attributes.district || "—" }}</b>
            </div>
            <div class="detail-row">
              <span>Cidade/UF</span
              ><b>{{ formatCity(selected.address_attributes) }}</b>
            </div>
            <div class="detail-row">
              <span>CEP</span
              ><b>{{ formatCep(selected.address_attributes.zip_code) }}</b>
            </div>
          </div>

          <div class="detail-card" v-if="selected.bank_account_attributes">
            <div class="detail-title">Dados bancários</div>
            <div class="detail-row">
              <span>Banco</span
              ><b>{{ selected.bank_account_attributes.bank_name || "—" }}</b>
            </div>
            <div class="detail-row">
              <span>Agência</span
              ><b>{{ formatAgency(selected.bank_account_attributes) }}</b>
            </div>
            <div class="detail-row">
              <span>Conta</span
              ><b>{{ formatBankNumber(selected.bank_account_attributes) }}</b>
            </div>
            <div
              class="detail-row"
              v-if="selected.bank_account_attributes.pix_key"
            >
              <span>Chave PIX</span
              ><b>{{ selected.bank_account_attributes.pix_key }}</b>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="details-actions">
          <router-link
            :to="{ name: 'partner', params: { id: selected.id } }"
            class="details-link"
          >
            <v-icon small color="primary">open_in_new</v-icon>
            Ver página completa
          </router-link>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed round @click="detailsDialog = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { changed } from "@/helpers/layout";

export default {
  props: ["row"],
  created() {
    this.$store.dispatch("partners/load");
  },
  components: {},
  computed: {
    ...mapGetters({
      partners: "partners/list",
      page: "partners/page",
      limit: "partners/limit",
      total: "partners/totalResources",
      isLoading: "partners/loadingData",
      limitOptions: "partners/limitOptions",
      showFilters: "partners/showFilters",
      filterParams: "partners/filterParams",
    }),
    pages() {
      return 0;
    },
  },
  data() {
    return {
      items: [],
      count: 0,
      pagination: {},
      isMobile: false,
      detailsDialog: false,
      selected: null,
      headers: [
        { text: "ID" },
        { text: "Criada em" },
        { text: "Nome" },
        { text: "Tipo de conta" },
        { text: "CPF" },
        { text: "CNPJ" },
        { text: "Parceria" },
        { text: "Plano" },
        { text: "Ações" },
      ],
    };
  },
  watch: {
    pagination: function pagination(newPagination, oldPagination) {
      if (changed(newPagination.rowsPerPage, oldPagination.rowsPerPage)) {
        this.setLimit(newPagination.rowsPerPage);
        this.$store.dispatch("partners/load", this.filterParams);
      }

      if (changed(newPagination.page, oldPagination.page)) {
        this.setCurrentPage(newPagination.page);
        this.$store.dispatch("partners/load", this.filterParams);
      }
    }
  },
  methods: {
    ...mapActions({
      setCurrentPage: "partners/setCurrentPage",
      setLimit: "partners/setLimit"
    }),
    setDateFormat(date) {
      if (date === null) {
        return "";
      }

      return new Date(date).toLocaleDateString("pt-BR");
    },
    openDetails(partner) {
      this.selected = partner;
      this.detailsDialog = true;
    },
    onlyDigits(value) {
      return String(value || "").replace(/\D/g, "");
    },
    formatCpf(value) {
      const d = this.onlyDigits(value);
      if (!d) return "—";
      if (d.length !== 11) return value;
      return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
    },
    formatCnpj(value) {
      const d = this.onlyDigits(value);
      if (!d) return "—";
      if (d.length !== 14) return value;
      return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    },
    formatCep(value) {
      const d = this.onlyDigits(value);
      if (!d) return "—";
      if (d.length !== 8) return value;
      return d.replace(/^(\d{5})(\d{3})$/, "$1-$2");
    },
    formatPhone(phone) {
      if (!phone || (!phone.area && !phone.number)) return "—";
      const area = this.onlyDigits(phone.area);
      const num = this.onlyDigits(phone.number);
      if (!area && !num) return "—";
      let masked = num;
      if (num.length === 9) masked = num.replace(/^(\d{5})(\d{4})$/, "$1-$2");
      else if (num.length === 8) masked = num.replace(/^(\d{4})(\d{4})$/, "$1-$2");
      return area ? `(${area}) ${masked}`.trim() : masked;
    },
    formatStreet(address) {
      if (!address || !address.street) return "—";
      return address.number
        ? `${address.street}, ${address.number}`
        : address.street;
    },
    formatCity(address) {
      if (!address || !address.city) return "—";
      return address.state
        ? `${address.city} / ${address.state}`
        : address.city;
    },
    formatAgency(bank) {
      if (!bank || !bank.agency) return "—";
      return bank.agency_digit
        ? `${bank.agency}-${bank.agency_digit}`
        : bank.agency;
    },
    formatBankNumber(bank) {
      if (!bank || !bank.number) return "—";
      return bank.number_digit
        ? `${bank.number}-${bank.number_digit}`
        : bank.number;
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },
};
</script>

<style>
  .partner-link {
    color: #1976d2;
    cursor: pointer;
    text-decoration: none;
    font-weight: 600;
  }

  .partner-link:hover {
    text-decoration: underline;
  }

  /* ===== Modal de detalhes ===== */
  .details-card {
    border-radius: 18px !important;
    overflow: hidden;
  }

  .details-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 20px;
    background: linear-gradient(135deg, #1976d2 0%, #2e9bff 100%);
    color: #fff;
  }

  .details-header-info {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .details-avatar {
    width: 46px;
    height: 46px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    flex-shrink: 0;
  }

  .details-name {
    font-size: 17px;
    font-weight: 700;
    line-height: 1.2;
    word-break: break-word;
  }

  .details-sub {
    font-size: 12px;
    opacity: 0.85;
    margin-top: 2px;
  }

  .details-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 14px 20px 4px;
  }

  .chip {
    font-size: 12px;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 999px;
    line-height: 1.6;
  }

  .chip-partner {
    background: #e3f2fd;
    color: #1565c0;
  }

  .chip-plan {
    background: #e8f5e9;
    color: #2e7d32;
  }

  .chip-muted {
    background: #eceff1;
    color: #607d8b;
  }

  .details-body {
    padding: 12px 20px 8px !important;
    background: #f7f9fb;
  }

  .detail-card {
    background: #fff;
    border: 1px solid #eceff1;
    border-radius: 14px;
    padding: 12px 16px;
    margin-bottom: 12px;
  }

  .detail-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: #1976d2;
    letter-spacing: 0.6px;
    margin-bottom: 6px;
  }

  .detail-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 6px 0;
    font-size: 14px;
    border-top: 1px solid #f2f4f6;
  }

  .detail-row:first-of-type {
    border-top: none;
  }

  .detail-row span {
    color: #90a4ae;
    margin-right: 12px;
    white-space: nowrap;
  }

  .detail-row b {
    color: #37474f;
    text-align: right;
    word-break: break-word;
  }

  .details-actions {
    padding: 12px 20px !important;
    background: #f7f9fb;
    border-top: 1px solid #eceff1;
  }

  .details-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #1976d2;
    text-decoration: none;
    font-weight: 600;
    font-size: 13px;
  }

  .details-link:hover {
    text-decoration: underline;
  }

  .mobile {
    color: #333;
  }

  .table-size-limit {
    height: 500px;
    max-height: 500px;
    overflow-y: scroll;
  }

  .partners-table {
    border-radius: 14px !important;
    overflow: hidden;
  }

  .partners-table table.v-table thead th {
    font-weight: 700;
    color: #607d8b !important;
    background: #f7f9fb;
  }

  .partners-table table.v-table tbody tr:hover {
    background: #f1f7ff !important;
  }

  .table-size-limit::-webkit-scrollbar {
    border: 0px;
    padding: 2px 0;
    background-color: rgba(0, 0, 0, 0);
  }

  .table-size-limit::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #477DB4;
  }

  @media screen and (max-width: 768px) {
    .mobile table.v-table tr {
      max-width: 100%;
      position: relative;
      display: block;
    }

    .mobile table.v-table tr:nth-child(odd) {
      border-left: 6px solid #b2b2b8;
    }

    .mobile table.v-table tr:nth-child(even) {
      border-left: 6px solid #636366;
    }

    .mobile table.v-table tr td {
      display: flex;
      width: 100%;
      border-bottom: 1px solid #f5f5f5;
      height: auto;
      padding: 10px;
    }

    .mobile table.v-table tr td ul li:before {
      content: attr(data-label);
      padding-right: 0.5em;
      text-align: left;
      display: block;
      color: #999;
    }
    .v-datatable__actions__select {
      width: 50%;
      margin: 0px;
      justify-content: flex-start;
    }
    .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
      background: transparent;
    }
  }
  .flex-content {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .flex-item {
    padding: 5px;
    width: 50%;
    height: 40px;
    font-weight: bold;
    margin-top: 10px;
  }
  .v-chip.payment.all {
    background-color: #757575 !important;
  }
  .v-chip.payment.waiting {
    background-color: #546e7a !important;
  }
  .v-chip.payment.processing {
    background-color: #546e7a !important;
  }
  .v-chip.payment.approved {
    background-color: #33691e !important;
  }
  .v-chip.payment.cancelled {
    background-color: #b71c1c !important;
  }
  .v-chip.payment.completed {
    background-color: #1b5e20 !important;
  }
  .v-chip.payment.failed {
    background-color: #e53935 !important;
  }
  .v-chip.payment.refunded {
    background-color: #ef6c00 !important;
  }
  .v-chip.payment.anticipated {
    background-color: #006064 !important;
  }
</style>
